<script>
export default {
  components: {},
  props: {
    cargoTypeId: {
      type: [String, Number],
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      options: [],
      groupOptions: []
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    // 监听cargoTypeId变化，当有值时加载options
    cargoTypeId: {
      handler(newVal, oldVal) {
        // console.log('watch', newVal, ',', oldVal)
        if (!newVal && !oldVal) {
          // console.log('默认渲染')
          this.options = [];
          this.groupOptions = [];
        } else if (newVal && !oldVal) {
          // console.log('选中了值')
        } else if (!newVal && oldVal) {
          // console.log('取消了值')
        } else {
          // console.log('值变化了')
          this.options = [];
          this.groupOptions = [];
          this.selectedValue = null
        }
        this.initOptions();
      },
      immediate: true
    }
  },
  mounted() {

  },
  methods: {
    initOptions() {
      if (!this.cargoTypeId) {
        return;
      }

      this.loading = true;
      this.$store.dispatch('bu_cargoSpec/fetchOptions', {
        cargoTypeId: this.cargoTypeId,
      }).then(res => {
        this.options = res.data;

        // this.doGroupHandle()
      }).finally(() => {
        this.loading = false;
      });
    },
    doGroupHandle() {
      const _tmpGroupList = []
      this.options.forEach(item => {
        const groupField = item.groupName || '未知'
        const _group = _tmpGroupList.find(group => group.label === groupField)
        if (_group) {
          _group.children.push(item)
          return
        }
        _tmpGroupList.push({
          label: groupField,
          sort: item.groupId || 99,
          children: [item]
        })
      })
      const sortField = 'groupId'
      this.groupOptions = _tmpGroupList.sort((a, b) => a[sortField] - b[sortField])
    },
    async onChange(val) {
      if (Object.hasOwn(this.$attrs, 'allow-create')) {
        await this.$nextTick()
        const isCreated = this.$refs.select.showNewOption
        if (isCreated && val) {
          this.$emit('change', {
            _created: true,
            value: val,
            label: val
          })
          this.$emit('update:label', val)
          return
        }
      }
      const checkedItem = this.options.find(item => item.value === val)
      this.$emit('change', checkedItem)
      this.$emit('update:label', checkedItem?.label)
    }
  }
}
</script>

<template>
  <el-select
    ref="select"
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    filterable
    default-first-option
    clearable
    @change="onChange"
    style="width: 100%;"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<style lang="scss" scoped></style>
